// @flow

import { PROCEDURE_UPDATE } from "../actions"

export default ( state: any = {}, action: any ) => {
  switch ( action.type ) {
  case PROCEDURE_UPDATE:
    return action.procedure
  default:
    return state
  }
}





// WEBPACK FOOTER //
// ./src/reducers/procedure.jsx